export default __webpack_public_path__ + "assets/images/5e176ae5670a7e3889d13a82d873f0ca.jpg";